<template>
  <div>
    <div
      class="banniere-container"
      :style="styleObjectContainer"
      @click="isOuvert = !isOuvert"
    ></div>
    <div
      v-if="texteHTML || mixinEnvironnement_inEditor"
      :id="content.idHTML"
      class="right_slider ui-slideouttab-panel ui-slideouttab-right ui-slideouttab-panel-reverse"
      :class="[jel_getClassObject(content), { 'position-fixed': !mixinEnvironnement_inEditor }]"
      :style="styleObjectSlider"
    >
      <b-link
        class="handle ui-slideouttab-handle-rounded ui-slideouttab-handle ui-slideouttab-handle-reverse imageTracked"
        :data-component-gacategory="content.googleAnalyticsBannierreLaterale?.eventCategory"
        :data-component-gaaction="content.googleAnalyticsBannierreLaterale?.eventAction"
        :data-component-galabel="content.googleAnalyticsBannierreLaterale?.eventLabel"
        @click="isOuvert = !isOuvert"
      >
        {{ content.titre }}
      </b-link>
      <b-link class="icomoon icon-cross close-button" @click="isOuvert = !isOuvert"></b-link>
      <div
        class="texte-conteneur"
        :class="[{ 'overflow-auto': isPlusGrandEcran }]"
        v-html="texteHTML"
      ></div>
    </div>
  </div>
</template>

<script>
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

import { isJelMobile } from '@/helpers/AppHelpers';

export default {
  name: 'BanniereLaterale',
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isOuvert: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    styleObjectSlider() {
      return {
        bottom: `${this.content.position}%`,
        right: this.isOuvert ? `${0}px` : `-${this.largeurSlider}`,
        width: this.largeurSlider,
      };
    },
    styleObjectContainer() {
      return {
        width: `${this.isOuvert ? this.windowWidth : 0}px`,
        height: `${this.isOuvert ? this.windowHeight : 0}px`,
      };
    },
    largeurSlider() {
      const largeur = this.isPlusGrandEcran ? this.windowWidth - 40 : this.content.largeurDesktop;
      return isJelMobile() ? '100%' : `${largeur}px`;
    },
    texteHTML() {
      return isJelMobile() ? this.content.texteHTMLmobile : this.content.texteHTMLdesktop;
    },

    isPlusGrandEcran() {
      return this.content.largeurDesktop > this.windowWidth - 40;
    },
  },
};
</script>

<style scoped>
.ui-slideouttab-panel {
  transition: all 300ms ease-in-out;
  z-index: 100;
}

.ui-slideouttab-handle-rounded {
  display: block;
  position: absolute;
  bottom: -5px;
  left: -5px;
  border-top: #565454 solid 5px;
  border-left: #565454 solid 5px;
  border-right: #565454 solid 5px;
}

.close-button {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-top: 10px;
  margin-right: 13px;
}

.ui-slideouttab-handle {
  transform-origin: 0% 0%;
  transform: rotate(-90deg) translate(-100%, -100%);
  padding: 5px 10px;
  font: 1.7em/1.7em Arial, Helvetica, sans-serif;
  text-decoration: underline;
  line-height: 1.3em;
}
.ui-slideouttab-handle-reverse {
  transform-origin: 0% 100%;
  transform: rotate(-90deg);
}
.ui-slideouttab-handle-rounded {
  border-radius: 15px 15px 0 0;
}

.texte-conteneur {
  max-height: 615px;
}

.banniere-container {
  z-index: 99;
  position: fixed;
  top: 0;
  right: 0;
  opacity: 50%;
}
</style>
